import CryptoJS from "crypto-js";

// Load from .env (make sure to restart the dev server after adding .env)
const keyBase64 = process.env.REACT_APP_AES_KEY || "";
const ivBase64 = process.env.REACT_APP_AES_IV || "";

const key = CryptoJS.enc.Base64.parse(keyBase64);
const iv = CryptoJS.enc.Base64.parse(ivBase64);

/**
 * Encrypts a given text using AES with CBC mode.
 * @param {string} plainText - The text to be encrypted.
 * @returns {string} - The encrypted Base64 string.
 */
export const encryptUserId = (plainText) => {
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    //return encrypted.toString();
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64); // Correctly encode the ciphertext
};

/**
 * Decrypts an AES-encrypted text using CBC mode.
 * @param {string} encryptedText - The encrypted Base64 string.
 * @returns {string} - The decrypted plain text.
 */
export const decryptUserId = (encryptedText) => {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return decryptedBytes.toString(CryptoJS.enc.Utf8); // Convert decrypted bytes to UTF-8 string
};
